import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=47854106&"
import script from "./api.js?vue&type=script&lang=js&"
export * from "./api.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports